import styled from "styled-components"

const Panel = styled.div`
  background: rgba(0, 88, 144, 0.71);
  border-radius: 1rem;
  padding: 1rem;
`

export default Panel



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/Panel.js